import React from 'react';
import {SignUpContainer} from "./sign_up_styles";
import {LightButton} from "../common_style/button";
import {LightTextInput} from "../common_style/text_input";
import {LinkLight} from "../common_style/link";
import {Span} from "../common_style/text";
import {Colors, FontStyles} from "../constants";
// assets
import logo from '../../assets/icons/logo.png';
import eu_flag from '../../assets/icons/eu_flag.png';
import {Localization} from "localizations/languages";

function SignUpView(props) {
    return <SignUpContainer onSubmit={(e) => {
        e.preventDefault();
        props.onSubmit(e);
    }}>
        <img style={{width: '274px', marginTop: '47px', marginBottom: '55px'}} src={logo}/>
        <Span textStyle={FontStyles.titleLight}>{Localization.current.translation30}</Span>
        <div style={{height: '61px'}}/>
        <LightTextInput outlineColor={props.invalidMail ?  Colors.error : null} id="email" label={Localization.current.translation58} name={'email'} autoComplete={'e-mail'}/>
        <div style={{height: '17px'}}/>
        <LightTextInput outlineColor={props.invalidPass ?  Colors.error : null} type="password" id="password" label={Localization.current.translation26} name={'password'} autoComplete={'new-password'}/>
        <div style={{height: '17px'}}/>
        <LightTextInput outlineColor={props.invalidPass ?  Colors.error : null} type="password" id="password" label={Localization.current.translation26} name={'password'} autoComplete={'confirm-password'}/>
        <div style={{height: '60px', paddingTop: '10px'}}>
            <Span textStyle={FontStyles.error}>{props.errorMsg}</Span>
        </div>
        <LightButton>
            {Localization.current.translation31}
        </LightButton>
        <div style={{height: '109px'}}/>
        <div style={{display: 'flex', width: '320px', alignItems: 'center', marginBottom: '48px'}}>
            <img style={{height: '65px', marginRight: '20px'}} src={eu_flag}/>
            <Span textStyle={FontStyles.smallPrintLight}>This project is part of a project that has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement Nº822664</Span>
        </div>
    </SignUpContainer>
}

export default SignUpView;
